import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE';

export const {action: changeSelectedId} = createAction(`${domain}/CHANGE_SELECTED_INDEX`, id => ({id}));
